import { render } from "./inventory.vue?vue&type=template&id=48106d26"
import script from "./inventory.vue?vue&type=script&lang=js"
export * from "./inventory.vue?vue&type=script&lang=js"

import "./inventory.vue?vue&type=style&index=0&id=48106d26&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__